import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Role from '../../entities/role';
export function deleteRole(role: Role, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = role.id;}
const _work = workingSet();




role.status = 'D';
role.addedOn = newHRTimestamp();
role.addedBy = getCurrentUserId();
role.importSource = targetImportSource;
role.importId = mergeId;
store.dispatch(Actions.RoleActions.removeRoleQueue(role));
}


